import { getRootContextPath } from '../context-path';

let pendingRequests = 0;

export const get = async <ResponseType>(
  route: string,
  params?: string | string[][] | Record<string, string> | URLSearchParams
): Promise<ResponseType> => {
  return await request<ResponseType, unknown>('GET', route, null, false, params);
};

export const post = async <ResponseType, RequestType>(
  route: string,
  data: RequestType,
  addCsrfToken = false
): Promise<ResponseType> => {
  return await request<ResponseType, RequestType>('POST', route, data, addCsrfToken);
};

export const del = async <ResponseType, RequestType>(
  route: string,
  data: RequestType,
  addCsrfToken = false
): Promise<ResponseType> => {
  return await request<ResponseType, RequestType>('DELETE', route, data, addCsrfToken);
};

export const put = async <ResponseType, RequestType>(
  route: string,
  data: RequestType,
  addCsrfToken = false
): Promise<ResponseType> => {
  return await request<ResponseType, RequestType>('PUT', route, data, addCsrfToken);
};

const request = async <ResponseType, RequestType>(
  method: string,
  route: string,
  data: RequestType,
  addCsrfToken = false,
  params?: string | string[][] | Record<string, string> | URLSearchParams
): Promise<ResponseType> => {
  startRequest();

  const headers: HeadersInit = {
    'Content-Type': 'application/json'
  };
  if (addCsrfToken) {
    headers['X-CSRF-TOKEN'] = getCsrf();
  }

  const result = await fetch(getRootContextPath() + route + (params ? '?' + new URLSearchParams(params) : ''), {
    method: method,
    credentials: 'include',
    headers,
    body: data ? JSON.stringify(data) : undefined
  });

  stopRequest();

  if (result.status >= 400 && result.status < 600) {
    throw new Error(`Got status code ${result.status}.`);
  }

  const resultText = await result.text();
  return resultText ? JSON.parse(resultText) : {};
};

const getCsrf = (): string => {
  const csrfElement = document.querySelector('body');
  return csrfElement ? csrfElement.dataset['csrf'] || '' : '';
};

const startRequest = () => {
  if (pendingRequests === 0) {
    document.querySelector('as-loading-indicator')?.removeAttribute('invisible');
  }

  pendingRequests++;
};

const stopRequest = () => {
  pendingRequests--;

  if (pendingRequests === 0) {
    document.querySelector('as-loading-indicator')?.setAttribute('invisible', '');
  }
};
